"use client";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useMemo } from "react";
import { Avatar } from "@mui/material";

export default function Levitator({
	children,
	className,
	canLevitate = true,
}: {
	children: React.ReactNode;
	className: string;
	canLevitate?: boolean;
}) {
	const controls = useAnimation();

	// Genera posiciones iniciales aleatorias para x e y
	const initialX = useMemo(() => (Math.random() - 0.5) * 200, []);
	const initialY = useMemo(() => (Math.random() - 0.5) * 200, []);
	const delay = useMemo(() => Math.random(), []);

	useEffect(() => {
		controls
			.start({
				// Animación de aparición desde una posición aleatoria hacia el centro (0,0)
				opacity: [0, 1],
				x: [initialX, 0],
				y: [initialY, 0],
				transition: {
					opacity: { duration: 0.8, ease: "easeOut", delay },
					x: { duration: 0.8, ease: "easeOut", delay },
					y: { duration: 0.8, ease: "easeOut", delay },
				},
			})
			.then(() => {
				if (canLevitate)
					// Una vez concluida la aparición, inicia la animación de levitación
					controls.start({
						y: [0, -16, 0],
						transition: {
							y: { duration: 4, repeat: Infinity, ease: "easeInOut", delay },
						},
					});
			});
	}, [controls, initialX, initialY, delay]);

	const onHoverStart = () => {
		controls.start({ y: -16, transition: { duration: 0.2 } });
	};

	const onHoverEnd = () => {
		controls.start({
			y: [-16, 0, -16],
			transition: {
				y: { duration: 2, repeat: Infinity, ease: "easeInOut" },
			},
		});
	};

	return (
		<motion.div
			animate={controls}
			initial={{ opacity: 0, x: initialX, y: initialY }}
			onHoverStart={canLevitate ? onHoverStart : undefined}
			onHoverEnd={canLevitate ? onHoverEnd : undefined}
		>
			<Avatar className={`${className} `}>{children}</Avatar>
		</motion.div>
	);
}
